
import { ElasticSearchService, ESExtras } from '../../api-server/elastic-search.service';
import { deleteDoc, collection, collectionData, CollectionReference, doc, docData, DocumentData, DocumentReference, Firestore, getDocs, increment, limit, query, QueryDocumentSnapshot, serverTimestamp, setDoc, SnapshotOptions, updateDoc, WithFieldValue } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { toDate } from '../helpers/utils';

/**
 * Clase base para ser reutilizada en los db-services
 *  super(firestore, es, 'orders', esExtra, esSource)
 *
 * Se pueden customizar los serializadores.
 * 1.- Es se declara nuevamente esNormalize
 * 2.- Para ffirestore tenemos dosfunciones
 * this.genericConverter.toFirestore =  (data: WithFieldValue<Model>) => {....}
 * this.genericConverter.fromFirestore =  ( snapshot: QueryDocumentSnapshot, options: SnapshotOptions) => {....}
 *
 */
export abstract class EsFirestoreBase<Model> {
  public collection: CollectionReference<any>;
  private options;
  genericConverter = {
    toFirestore(data: WithFieldValue<Model>): DocumentData {
      return data as DocumentData;
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot,
      options: SnapshotOptions
    ): Model {
      const data = snapshot.data(options)!;
      data.createdAt = toDate(data.createdAt);
      data.updatedAt = toDate(data.updatedAt);
      return data as Model;
    }
  };
  esNormalize = (item:any) => {
    item.createdAt = item.createdAt ? new Date(item.createdAt._seconds * 1000) : null;
    return item;
  };

  constructor(
    protected firestore: Firestore,
    protected es: ElasticSearchService,
    protected collectionName:string,
    protected esExtras:ESExtras = null,
    protected esSource:Array<string> = null,
  ) {
    if (this.firestore){
      this.collection = collection(this.firestore, this.collectionName).withConverter(this.genericConverter);
    }
  }
  get$(id:string): Observable<Model> {
    const docRef = doc(this.collection, id);
    return docData(docRef, { idField: 'id' as keyof Model}) as Observable<Model>;
  }

  getAll$():Observable<Model[]> {
    const _query = query(this.collection, limit(100))
    return collectionData(_query, {idField:'id'}) as Observable<Model[]>;
  }

  upsert(_data, isNew=false): Promise<any> {
    const { id, ...data } = _data;
    data.updatedAt = serverTimestamp();
    data._version = increment(1);
    if(isNew || !id) {
      data.createdAt = serverTimestamp() 
    } 
    const merge = !(isNew || !id);
    const docRef:DocumentReference = id ? doc(this.collection, id) : doc(this.collection);
    return setDoc(docRef, data, {merge}).then(()=> docRef.id)
  }

  delete(id):Promise<any>{
    const docRef = doc(this.collection, id);
    return deleteDoc(docRef);
  }

  onChange(): Observable<any> {
    const docRef = doc(this.firestore,'refresh', this.collectionName);
    return docData(docRef) as Observable<any>;
  }

  async query(paginator, sort, filter, options?){
    const extras = this.esExtras;
    const source = this.esSource;
    const index = this.collectionName;
    const body = this.es.mtToBody(paginator, sort, filter, extras, source);
    return this.es.query(index , body, this.esNormalize);
  }

}

